import {FC, ReactElement, useCallback, useEffect, useState} from 'react';
import styled from 'styled-components';
import home_authentication_bg from '../../assets/images/home_authentication_bg.png'
import Server from "utils/serviceApi";
import {useSelector} from "react-redux";
import {AppState} from "@/state";
import {sleep} from "utils/met";
import Message from "components/toasts/toasts";
import {useTranslation} from "react-i18next";
import {CopyToClipboard} from 'react-copy-to-clipboard'
import useInterval from "hooks/useInterval";

const Main = styled.div`
  width: 100%;
  padding: 0.72rem 0 0.36rem;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: space-between;
  background: url(${home_authentication_bg}) no-repeat center;
  background-size: 100% 100%;
  min-height: 100%;

  a {
    border: solid 0.01rem transparent;
    color: #08BDC7;
    min-width: 90%;
    font-size: 0.16rem;
    border-radius: 0.22rem;
    height: 0.44rem;
    text-align: center;
    line-height: 0.44rem;
    background-image: linear-gradient(#fbfaec, #eff6da), linear-gradient(164deg, rgba(72, 176, 254, 1), rgba(23, 250, 218, 1));
    background-origin: border-box;
    background-clip: content-box, border-box;
  }
`;

const CheckDiv = styled.div`
  width: 100%;
  overflow: hidden;
  padding: 0.72rem 0 0.36rem;
  display: flex;
  flex-direction: column;
  align-items: center;
  background-size: 100% 100%;
  min-height: 100%;
  font-size: 0.12rem;
  font-weight: 400;
  position: relative;
  color: #333333;

  .title {
    display: flex;
    align-items: center;
    justify-content: center;
    height: 0.6rem;
  }

  h1 {
    font-size: 0.18rem;
    padding: 0 0.12rem;
    font-weight: bold;
    line-height: 0.24rem;
    text-align: center;
    color: #08BDC7;
  }

  .card {
    width: 100%;
    margin-top: 0.32rem;
    margin-bottom: 0.18rem;
  }

  .bottom-div {
    position: absolute;
    bottom: 0.32rem;
  }

  .bottom_content {
    display: flex;
    justify-content: center;
    align-items: center;
    font-size: 0.12rem;
    font-weight: 400;
    color: #08BDC7;
    margin-top: 0.08rem;

    p {
      margin: 0 0.08rem;
    }

    img {
      width: 0.16rem;
    }
  }


  .magnifier {
    height: 1.1rem;
    animation: spin-reverse 2s infinite linear;
  }

  .cirle-move {
    position: absolute;
    top: 2.1rem;
    right: 0.36rem;
    animation: spin 2s infinite linear;
    transform-origin: 0.64rem 0.64rem;
  }

  @keyframes spin {
    to {
      transform: rotate(1turn);
    }
  }

  @keyframes spin-reverse {
    to {
      transform: rotate(-1turn);
    }
  }
`;

const Text = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 0.13rem;
  font-weight: 400;
  color: #08BDC7;

  img {
    width: 0.16rem;
  }
`
const TopElementImg = styled.img.attrs(props => ({
    src: props.src,
    alt: props.alt,
}))`
  width: 2.2rem;
`;

const CenterElementImg = styled.img.attrs(props => ({
    src: props.src,
    alt: props.alt,
}))`
  width: 3.12rem;
`;

const Success: FC = (): ReactElement => {
    const {t} = useTranslation();
    const {account} = useSelector((state: AppState) => state.baseInfo)
    const [messageVal, setMessageVal] = useState('')
    const [checkVisible, setCheckVisible] = useState<boolean>(true)
    const [refresh, setRefresh] = useState<boolean>(false)
    const [refreshCount, setRefreshCount] = useState<number>(0)
    const {
        getTableRowsByNFT, getTableRowsByVendorinfo
    } = Server

    const handleComing = async () => {
        setMessageVal(t('home.ComingSoon'))
        await sleep(2000)
        setMessageVal('')
    }
    useInterval(async () => {
        if (account.name && refreshCount < 2) {
            setRefresh(!refresh)
            setRefreshCount(refreshCount + 1)
        }

    }, 5000)
    useEffect(() => {
        const initData = async () => {
            if (account.name) {
                try {
                    const vendorinfoData = await getTableRowsByVendorinfo()
                    const nft_id = vendorinfoData.rows[0].nft_id.id
                    const nftData = await getTableRowsByNFT(account.name)
                    let nftAmount = 0
                    if (nftData && nftData.rows) {
                        const nftObj = nftData.rows.find(item => item.balance.symbol.id === nft_id)
                        if (nftObj) {
                            nftAmount = nftObj.balance.amount
                        }
                    }
                    if (nftAmount > 0) {
                        setCheckVisible(false)
                    } else {
                        setCheckVisible(true)
                    }

                } catch (e) {
                    console.log(e)
                }

            }
        }
        void initData()

    }, [account.name, account.publicKey, getTableRowsByVendorinfo, getTableRowsByNFT, refresh])
    const copyUrlChange = useCallback(
        async (text, result) => {
            if (result) {
                setMessageVal(t('home.Copied'))
                await sleep(2000)
                setMessageVal('')
            }
        },
        [t]
    )
    return (
        <>
            {checkVisible ? <CheckDiv>
                <div className='title'>
                    <h1>{t('home.verified')}</h1>
                </div>
                <img className='card' src={require('img/card.png').default} alt=""/>
                <div className="cirle-move">
                    <img className="magnifier" src={require('img/card_loading.png').default} alt=""/>
                </div>

                <p style={{marginTop: '0.12rem',textAlign:'center',fontSize:'0.12rem',color:'#434347'}}>{t('home.youCheckLater')}</p>
                <div className='bottom-div'>
                    <p >{t('home.contactTelegram')}</p>
                    <CopyToClipboard text="https://t.me/Armonia_AMC" onCopy={copyUrlChange}>
                        <div className='bottom_content'>
                            <img src={require('img/icon_telegram.png').default} alt=""/>
                            <p>https://t.me/Armonia_AMC</p>
                            <img src={require('img/icon_copy.png').default} alt=""/>
                        </div>
                    </CopyToClipboard>
                </div>
            </CheckDiv> : <Main>

                <TopElementImg src={require('img/did_verification_text.png').default} alt=""/>
                <CenterElementImg src={require('img/did_verification_img.png').default} alt=""/>
                <a href='https://f2m.aplink.app/' target='_blank'
                   rel='noreferrer'>{t('home.goFarming')}</a>
                <Text onClick={() => handleComing()}>
                    <p>{t('home.getMore')}</p>
                    <img src={require('img/tips_see_icon.png').default} alt=""/>
                </Text>
            </Main>}

            {messageVal && <Message content={messageVal}/>}
        </>
    );
}
;

export default Success;
